/*
 * Bushnell — mouse/pen drag-to-scroll for horizontal carousels.
 *
 * Touch devices already swipe natively on any overflow-x container, so this
 * only handles mouse/pen: click-drag anywhere on a horizontally scrollable
 * carousel to slide it, on every such carousel site-wide (no per-section
 * markup needed). A real drag suppresses the click that follows, so cards and
 * links don't fire when you were just dragging.
 */
(function () {
  if (window.__bnDragScroll) return;
  window.__bnDragScroll = true;

  var MIN_OVERFLOW = 8;    // px of horizontal overflow to treat it as a carousel
  var DRAG_START = 6;      // px of movement before it counts as a drag (vs a click)

  /* Nearest ancestor (incl. self) that actually scrolls horizontally. */
  function scrollableX(el) {
    while (el && el.nodeType === 1 && el !== document.body) {
      if (el.scrollWidth - el.clientWidth > MIN_OVERFLOW) {
        var ox = getComputedStyle(el).overflowX;
        if (ox === 'auto' || ox === 'scroll') return el;
      }
      el = el.parentElement;
    }
    return null;
  }

  var target = null, startX = 0, startScroll = 0, pointerId = null, dragging = false;
  var suppressClick = false, suppressTimer = null;

  /* Sliders that manage their own drag/swipe — don't double-handle them. */
  var SELF_MANAGED = 'slideshow-component, slideshow-slides, .embla, .embla__viewport, [data-bpdp-track], swiper-container, .swiper';

  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'touch') return;      // native momentum handles touch
    if (e.button !== 0) return;                 // left button only
    if (!e.target.closest) return;
    if (e.target.closest('input, textarea, select, [contenteditable="true"]')) return;
    if (e.target.closest(SELF_MANAGED)) return; // Embla / theme slideshow handle their own drag
    var sc = scrollableX(e.target);
    if (!sc) return;
    target = sc;
    startX = e.clientX;
    startScroll = sc.scrollLeft;
    pointerId = e.pointerId;
    dragging = false;
    suppressClick = false;
  }, true);

  document.addEventListener('pointermove', function (e) {
    if (!target || e.pointerId !== pointerId) return;
    var dx = e.clientX - startX;
    if (!dragging) {
      if (Math.abs(dx) < DRAG_START) return;
      dragging = true;
      target.classList.add('bn-dragging');
      document.body.style.userSelect = 'none';
    }
    target.scrollLeft = startScroll - dx;
    e.preventDefault();
  }, true);

  function endDrag() {
    if (!target) return;
    if (dragging) {
      target.classList.remove('bn-dragging');
      document.body.style.userSelect = '';
      suppressClick = true;                     // a real drag → swallow the next click
      clearTimeout(suppressTimer);
      suppressTimer = setTimeout(function () { suppressClick = false; }, 300);
    }
    target = null;
    pointerId = null;
    dragging = false;
  }

  document.addEventListener('pointerup', endDrag, true);
  document.addEventListener('pointercancel', endDrag, true);

  document.addEventListener('click', function (e) {
    if (suppressClick) {
      suppressClick = false;
      clearTimeout(suppressTimer);
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
})();
